import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Braces } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function VariablePills({ columns, onInsert }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      data-testid="variable-pills-section"
    >
      <div className="flex items-center gap-2 mb-3">
        <Braces className="w-4 h-4 text-primary" />
        <h3 className="text-sm font-bold tracking-wide uppercase text-zinc-500">
          Variables disponibles
        </h3>
      </div>
      <p className="text-xs text-zinc-400 mb-3">
        Cliquez pour insérer dans le champ actif
      </p>
      <TooltipProvider delayDuration={200}>
        <div className="flex flex-wrap gap-2" data-testid="variable-pills-container">
          {columns.map((col, i) => (
            <Tooltip key={col}>
              <TooltipTrigger asChild>
                <motion.button
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: i * 0.05 }}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-zinc-200 bg-white text-xs font-mono text-zinc-700 hover:border-primary hover:text-primary hover:bg-primary/5 transition-all duration-200 cursor-pointer active:scale-95"
                  onClick={() => onInsert(`{${col}}`)}
                  data-testid={`variable-pill-${col}`}
                >
                  <Braces className="w-3 h-3" />
                  {col}
                </motion.button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Insérer {`{${col}}`}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      </TooltipProvider>
    </motion.div>
  );
}
